import CartulinaContainer from './containers/cartulina-container';
export { default as CartulinaCanvas } from './components/cartulina-canvas';
export default CartulinaContainer;